/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Outsideairco2defect4Inputs */



/**
* | output |
* | --- |
* | "Fresh air CO2 sensor fault" |
*
* @param {Ahu_History_Key_Outsideairco2defect4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_outsideairco2defect4 = /** @type {((inputs?: Ahu_History_Key_Outsideairco2defect4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Outsideairco2defect4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air CO2 sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde CO2 air neuf")
});
export { ahu_history_key_outsideairco2defect4 as "ahu_history_key_outsideAirCO2Defect" }